import isEmail from 'validator/lib/isEmail'
import isURL from 'validator/lib/isURL'

export default values => {
  const errors = {}

  if (!values.name) {
    errors.name = 'Shop name is required'
  }

  if (!values.url) {
    errors.url = 'Shop URL is required'
  } else if (isEmail(values.url) || !isURL(values.url, {allow_underscores: true, require_tld: false})) {
    errors.url = 'Incorrect Shop URL (e.g. www.yourwebsite.com)'
  }

  if (!values.platform) {
    errors.platform = 'Platform is required'
  }

  if (!values.currency) {
    errors.currency = true
  }

  if (!values.industry) {
    errors.industry = 'Industry is required'
  }

  if (!values.timezone) {
    errors.timezone = 'Timezone is required'
  }

  return errors
}



// WEBPACK FOOTER //
// ./client/components/Wizard/validate.js